exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(/landing/css/app.css);", ""]);

// module
exports.push([module.id, "tr:nth-child(2n){background-color:#f7fafc}", ""]);

// exports
